import React from 'react'
import { CheckBoxField } from '@sencha/ext-modern'

import { getMixedProps } from './blockPublic'

// 取Field的requiredMessage信息
// let requiredMessage = 'required'
// Tyan.onReady(()=>(requiredMessage = Ext.field.Field.getConfigurator().values.requiredMessage))

const CheckBoxSingle = ({ config: { field, onChange, initValues, changedValues, defaultStyle, that } }) => {
	const { props: { checkedValue, uncheckedValue, ...props } } = getMixedProps('_checkboxSingle', [defaultStyle, field])
	let { name, value } = field

	const handleChange = (field, bSelected) => {
		onChange({
			name,
			newValue: bSelected ? checkedValue : uncheckedValue,
			type: Array.isArray(checkedValue) ? 'array' : typeof (checkedValue)
		})
	}

	return <CheckBoxField {...props}
		checked={!!value}
		onChange={handleChange}
	/>
}

const renderCheckBoxSingle = config => {
	const { field: { key } } = config
	return <CheckBoxSingle key={key} config={config} />
}

export default renderCheckBoxSingle